import React, { useEffect } from 'react';

const YotpoReviewsWidget = ({ productId, price, currency, name, url, image }) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML =
      '(function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="https://cdn-widgetsrepository.yotpo.com/v1/loader/iSFjwx0v1ovunmIySzHgKie7UkFruOwYIiq9II4E";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (window.yotpoWidgetsContainer) {
      window.yotpoWidgetsContainer.initWidgets();
    } else if (window.yotpo) {
      window.yotpo.refreshWidgets();
    }
  }, [url]);

  return (
    <div>
      <div
        className="yotpo-widget-instance"
        data-yotpo-instance-id="1024631"
        data-yotpo-product-id={productId}
        data-yotpo-name={name}
        data-yotpo-url={url}
        data-yotpo-image-url={image}
        data-yotpo-price={price}
        data-yotpo-currency="USD"
        data-yotpo-description="Product Description"
      ></div>
    </div>
  );
};

export default YotpoReviewsWidget;